<template>
  <section class="content">
    <div class="primary-header">
      <h1 data-qa="Content-User-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
    </div>
    <hamv-info-box :title="$t('userInfoBoxTitleUsersText')" :total="total.users || '--'" classes="fa fa-user"></hamv-info-box>
    <div class="user-search">
      <el-input
        :placeholder="$t('userInputSearchBarPlaceholder')"
        @keyup.enter.native="userSearch(searchQuery)"
        clearable
        name="searchQuery"
        type="text"
        v-model.lazy="searchQuery"
        v-validate="'min:4|max:50'"
      >
        <el-button @click="userSearch(searchQuery)" :disabled="errors.has('searchQuery')" icon="el-icon-search" slot="append"></el-button>
      </el-input>
      <span class="error-message" v-show="errors.has('searchQuery')">{{ $t('userInputSearchBarError') }}</span>
    </div>
    <el-table
      @expand-change="handleExpand"
      @cell-click="toggleRowExpansion"
      :element-loading-text="$t('userTableLoadingText')"
      :empty-text="$t('userTableEmptyText')"
      :expand-row-keys="expanded"
      :data="userList"
      :row-key="getRowKey"
      class="user-table"
      data-qa="Content-User-Table"
      element-loading-background="#FFFFFF"
      fit
      max-height="100%"
      ref="userListTable"
      row-class-name="pointer"
      show-header
      v-loading="isLoading"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <user-info :user="userInfo" :loading="isLoadingInfo"></user-info>
        </template>
      </el-table-column>
      <el-table-column :label="$t('userTableColEmailLabel')" sortable prop="email" min-width="210" column-key="email"></el-table-column>
      <el-table-column :label="$t('userTableColRegisteredTimeLabel')" min-width="250" column-key="registeredTime">
        <template slot-scope="scope">
          <span>{{ convertTime(scope.row.creation_date) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('userTableColActivateLabel')" sortable prop="status" min-width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="toggleStatus(scope.row.id, scope.row.status)"
            :disabled="isAdmin(scope.row.email)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column min-width="40">
        <template slot-scope="scope">
          <el-tooltip :content="$t('userTooltipDeleteText')" effect="dark" placement="top-start">
            <el-button
              :data-qa="'Content-DeleteUser-Button-' + scope.row.id"
              @click.stop="deleteUser(scope.row.id, scope.row.email)"
              size="mini"
              type="text"
            >
              <i class="fa fa-trash fa-2 operation-icons"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-row type="flex" justify="center" v-if="showPagination">
      <el-pagination
        :current-page.sync="pagination.currentPage"
        :disabled="isLoading"
        :layout="pagination.layout"
        :page-size="pagination.limit"
        :total="searchedTotal"
        @current-change="getCurrentPageUser"
        background
      >
      </el-pagination>
    </el-row>
    <user-delete></user-delete>
  </section>
</template>

<script>
  import main from './User.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './User.scss';
</style>



// WEBPACK FOOTER //
// User.vue?0ea46852